export default "__VITE_PUBLIC_ASSET__9a9f9bee__"